<template>
    <div class="FooterWithObjectAppointment">
        <Footer/>
    </div>
</template>

<script>
import Footer from "@/components/Footer";

export default {
    name: "FooterWithObjectAppointment",
    components: {
        Footer,
    },
}
</script>

<style lang="scss">
.FooterWithObjectAppointment {
  background-color: $primary;
  padding: 0 50px 75px;
  margin-bottom: -50px;

  @include mobile {
    padding: 0;
    padding-bottom: 50px;
  }

  .Footer {

    @include mobile {
      padding: 0 48px;
    }

    &__photo {
      @include mobile {

        margin-left: 0;
      }
    }

    .container {
      padding: 0;
    }
  }
}
</style>